export const getZendeskTicketURL = ({
  subdomain,
  ticketID,
}: {
  subdomain: string;
  ticketID: string;
}) => {
  return `https://${subdomain}.zendesk.com/agent/tickets/${ticketID}`;
};
